import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import AIPlatformInfographic from "./components/AIPlatformInfographic";
import ZeroToHeroInfographic from "./components/ZeroToHeroInfographic";
import AICapabilitiesGrid from "./components/AICapabilitiesGrid";
import About from "./components/About";
import Products from "./components/Products";
// import Testimonials from "./components/Testimonials";
// import Team from "./components/Team";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <ErrorBoundary>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={
              <div className="overflow-hidden">
                <Header />
                <Hero />
                <Services />
                <AIPlatformInfographic />
                <AICapabilitiesGrid />
                {/* <UseCases /> */}
                {/* <Industries /> */}
                 <Products />
                <ZeroToHeroInfographic />
                <About />
               
                {/* <Portfolio /> */}
                {/* <Testimonials /> */}
                {/* <Team /> */}
                <Contact />
                <Footer />
              </div>
            } />
          </Routes>
        </BrowserRouter>
      </div>
    </ErrorBoundary>
  );
}

export default App;